import React from 'react';
import { useBrandingData, useFeatureEnables } from '../dataProviders';

import { NavLink } from './BtLink';


export default function NavLinks({ linkClassName='' }) {
  const { showMenuLinks } = useFeatureEnables();
  const { menu_links } = useBrandingData();

  if( !showMenuLinks ) {
    return null;
  }

  return <>
    {menu_links.filter( item => (item && item.url && item.text) ).map( ({ url, text }) => (
      <NavLink className={linkClassName} key={url} href={url}>{text}</NavLink>
    ))}
  </>
}